module.exports = __webpack_public_path__ + "fasaw5.png?6031cecf88680cf62af495eb2716549b";